import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  footerClass?: string;
}

const ClickHandler = (): void => {
  window.scrollTo(10, 0);
};

const Footer: React.FC<FooterProps> = ({ footerClass }) => {
  return (
    <footer className={`wpo-site-footer ${footerClass || ""}`}>
      <div className="container">
        {/* Upper Footer */}
        <div className="wpo-upper-footer">
          <div className="row">
            {/* Left Text Section */}
            <div className="col col-lg-7 col-md-6 col-sm-12 col-12">
              <div className="footer-title-left">
                <h2>
                  We can’t wait to see all of our beloved friends and relatives
                  at our wedding. Your presence will make our day truly special!
                </h2>
              </div>
            </div>

            {/* Links Section */}
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Links</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/about">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/story">
                      Story
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/rsvp">
                      RSVP
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/gallery">
                      Gallery
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contacts Section */}
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Contacts</h3>
                </div>
                <ul>
                  <li>
                    <a href="mailto:bohu@gmail.com">bohu@gmail.com</a>
                  </li>
                  <li>
                    <a href="tel:+3165550116">+316555-0116</a>
                  </li>
                  <li>4517 Washington Ave. Manchester, Kentucky 39495</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Lower Footer */}
        <div className="wpo-lower-footer">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                Copyright © <span>2025 </span> |{" "}
                <Link onClick={ClickHandler} to="/home">
                  Bohu
                </Link>{" "}
                | All Rights Reserved
              </p>
            </div>

            <div className="col col-lg-6 col-12">
              <ul className="links">
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-facebook" aria-label="Facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-twitter-alt" aria-label="Twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-instagram" aria-label="Instagram"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
